import React, { useState } from "react";

const MovieOverlay = ({ movie }) => {
  const [isOpen, setIsOpen] = useState(false);
  console.log(movie);

  const handleOpen = () => {
    setIsOpen(true);
  };

  const handleClose = () => {
    setIsOpen(false);
  };

  return (
    <>
      <button
        className="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded"
        onClick={handleOpen}
      >
        View Details
      </button>
      {isOpen && (
        <div className="fixed z-10 inset-0 overflow-y-auto">
          <div className="flex items-center justify-center min-h-screen">
            <div
              className="bg-white rounded-lg shadow-lg p-8 max-w-2xl relative"
              onClick={(e) => e.stopPropagation()}
            >
              <button
                className="absolute top-4 right-4 text-gray-500 hover:text-gray-700"
                onClick={handleClose}
              >
                <svg
                  className="h-6 w-6"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M6 18L18 6M6 6l12 12"
                  />
                </svg>
              </button>
              <div className="flex">
                <img
                  src={movie.Poster}
                  alt={movie.Title}
                  className="w-48 h-72 object-cover rounded-lg mr-6"
                />
                <div>
                  <h2 className="text-2xl font-bold mb-2">{movie.Title}</h2>
                  <p className="text-gray-600 mb-2">Type: {movie.Type}</p>
                  <p className="text-gray-600 mb-2">Year: {movie.Year}</p>
                  <p className="text-gray-600 mb-2">IMDB ID: {movie.imdbID}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default MovieOverlay;
